// extracted by mini-css-extract-plugin
module.exports = {"row":"Customstrap_row_3YJNG","col":"Customstrap_col_2eaCc"};